import { _t, getLocale } from '@/i18n/t';

export const formatShortDate = (iso: string) =>
  new Date(iso).toLocaleDateString(getLocale(), { month: 'short', day: 'numeric' });

const ORDINAL_CATEGORIES = new Set(['one', 'two', 'few', 'other']);

export const formatOrdinal = (n: number) => {
  const category = new Intl.PluralRules(getLocale(), { type: 'ordinal' }).select(n);
  return _t(`visibilityReport.ordinal.${ORDINAL_CATEGORIES.has(category) ? category : 'other'}`, { n });
};

export const joinNames = (names: string[]) => {
  if (names.length <= 1) return names[0] ?? '';
  return _t('visibilityReport.list.and', {
    rest: names.slice(0, -1).join(_t('visibilityReport.list.separator')),
    last: names[names.length - 1] as string,
  });
};

export const countryName = (code: string | null) => {
  if (!code) return null;
  try {
    return new Intl.DisplayNames([getLocale()], { type: 'region' }).of(code.toUpperCase()) ?? null;
  } catch {
    return null;
  }
};

export const siteLabel = (site: string | null) => (site ? site.charAt(0).toUpperCase() + site.slice(1) : '');

export const pluralKey = (base: string, n: number) => `${base}${n === 1 ? 'One' : 'Other'}`;

const ENGINE_DOMAINS: Record<string, string> = {
  chatgpt: 'chatgpt.com',
  claude: 'claude.ai',
  gemini: 'gemini.google.com',
  perplexity: 'perplexity.ai',
  'google ai mode': 'google.com',
};

export const engineDomain = (engine: string) => ENGINE_DOMAINS[engine.toLowerCase()] ?? `${engine.toLowerCase()}.com`;
